/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoPowerChargeLogListPowerChargeLogData model module.
 * @module model/LogControllerDtoPowerChargeLogListPowerChargeLogData
 * @version 1.0
 */
class LogControllerDtoPowerChargeLogListPowerChargeLogData {
    /**
     * Constructs a new <code>LogControllerDtoPowerChargeLogListPowerChargeLogData</code>.
     * @alias module:model/LogControllerDtoPowerChargeLogListPowerChargeLogData
     */
    constructor() { 
        
        LogControllerDtoPowerChargeLogListPowerChargeLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoPowerChargeLogListPowerChargeLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoPowerChargeLogListPowerChargeLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoPowerChargeLogListPowerChargeLogData} The populated <code>LogControllerDtoPowerChargeLogListPowerChargeLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoPowerChargeLogListPowerChargeLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('beforePower')) {
                obj['beforePower'] = ApiClient.convertToType(data['beforePower'], 'Number');
            }
            if (data.hasOwnProperty('beforeMaxPower')) {
                obj['beforeMaxPower'] = ApiClient.convertToType(data['beforeMaxPower'], 'Number');
            }
            if (data.hasOwnProperty('maxExtraPower')) {
                obj['maxExtraPower'] = ApiClient.convertToType(data['maxExtraPower'], 'Number');
            }
            if (data.hasOwnProperty('dailyExtraPowerUsed')) {
                obj['dailyExtraPowerUsed'] = ApiClient.convertToType(data['dailyExtraPowerUsed'], 'Number');
            }
            if (data.hasOwnProperty('afterPower')) {
                obj['afterPower'] = ApiClient.convertToType(data['afterPower'], 'Number');
            }
            if (data.hasOwnProperty('afterMaxPower')) {
                obj['afterMaxPower'] = ApiClient.convertToType(data['afterMaxPower'], 'Number');
            }
            if (data.hasOwnProperty('nftUidList')) {
                obj['nftUidList'] = ApiClient.convertToType(data['nftUidList'], 'String');
            }
            if (data.hasOwnProperty('itemIdList')) {
                obj['itemIdList'] = ApiClient.convertToType(data['itemIdList'], 'String');
            }
            if (data.hasOwnProperty('lastPowerChargeAt')) {
                obj['lastPowerChargeAt'] = ApiClient.convertToType(data['lastPowerChargeAt'], 'Date');
            }
            if (data.hasOwnProperty('lastMaxPowerResetAt')) {
                obj['lastMaxPowerResetAt'] = ApiClient.convertToType(data['lastMaxPowerResetAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoPowerChargeLogListPowerChargeLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoPowerChargeLogListPowerChargeLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['nftUidList'] && !(typeof data['nftUidList'] === 'string' || data['nftUidList'] instanceof String)) {
            throw new Error("Expected the field `nftUidList` to be a primitive type in the JSON string but got " + data['nftUidList']);
        }
        // ensure the json data is a string
        if (data['itemIdList'] && !(typeof data['itemIdList'] === 'string' || data['itemIdList'] instanceof String)) {
            throw new Error("Expected the field `itemIdList` to be a primitive type in the JSON string but got " + data['itemIdList']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['email'] = undefined;

/**
 * @member {Number} beforePower
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['beforePower'] = undefined;

/**
 * @member {Number} beforeMaxPower
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['beforeMaxPower'] = undefined;

/**
 * @member {Number} maxExtraPower
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['maxExtraPower'] = undefined;

/**
 * @member {Number} dailyExtraPowerUsed
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['dailyExtraPowerUsed'] = undefined;

/**
 * @member {Number} afterPower
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['afterPower'] = undefined;

/**
 * @member {Number} afterMaxPower
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['afterMaxPower'] = undefined;

/**
 * @member {String} nftUidList
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['nftUidList'] = undefined;

/**
 * @member {String} itemIdList
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['itemIdList'] = undefined;

/**
 * @member {Date} lastPowerChargeAt
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['lastPowerChargeAt'] = undefined;

/**
 * @member {Date} lastMaxPowerResetAt
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['lastMaxPowerResetAt'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoPowerChargeLogListPowerChargeLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoPowerChargeLogListPowerChargeLogData;

